import { render, staticRenderFns } from "./setting-ap-prompt.vue?vue&type=template&id=d287fac6&scoped=true"
import script from "./setting-ap-prompt.vue?vue&type=script&lang=js"
export * from "./setting-ap-prompt.vue?vue&type=script&lang=js"
import style0 from "./setting-ap-prompt.vue?vue&type=style&index=0&id=d287fac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d287fac6",
  null
  
)

export default component.exports